




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { container } from 'tsyringe';
import { MediaService } from '@/core/media/services/MediaService';
import { SharedMedium } from '@/core/media/models/SharedMedium';
import { StorageFileQuality } from '@/core/campaign/enums/Campaign';
import VideoComposition from '@/ui/components/atoms/VideoComposition.vue';
import getLogger from '@/shared/logger/logger';

const LOG = getLogger('ShareMediaView');

@Component({
  name: 'ShareMediaView',
  components: { VideoComposition },
})
export default class ShareMediaView extends Vue {
  @Prop({ required: true }) secret!: string;

  private medium: SharedMedium | null = null;
  private isLoading = true;
  private hasError = false;

  async created() {
    try {
      const mediaService = container.resolve<MediaService>('MediaService');
      this.medium = await mediaService.getMediumByShareSecret(this.secret);
    } catch (e) {
      LOG.error(`Failed to load shared medium: ${e}`);
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  get source(): string | undefined {
    return this.medium?.files?.find(
      ({ quality }) => quality === StorageFileQuality.ORIGINAL || quality === StorageFileQuality.CONVERTED,
    )?.storagePath;
  }

  get fileName(): string | undefined {
    return this.medium?.fileName;
  }

  get isImage(): boolean {
    return !!this.medium?.contentType?.match('image.*');
  }

  get isVideo(): boolean {
    return !!this.medium?.contentType?.match('video.*');
  }
}
